module.exports = __webpack_public_path__ + "static/media/mic-off-32px.15070c4a.svg";